import React from 'react';

function Icon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      data-testid='icon_add'
      width='24'
      height='24'
      fill='none'
      viewBox='0 0 24 24'
    >
      <path fill='none' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M12 5v14' />
      <path fill='none' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M5 12h14' />
    </svg>
  );
}

export default Icon;
